var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 24.5V22.1667C18.6663 20.929 18.1747 19.742 17.2995 18.8668C16.4243 17.9917 15.2374 17.5 13.9997 17.5H6.99967C5.762 17.5 4.57501 17.9917 3.69984 18.8668C2.82467 19.742 2.33301 20.929 2.33301 22.1667V24.5",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 12.8333C13.077 12.8333 15.1663 10.744 15.1663 8.16667C15.1663 5.58934 13.077 3.5 10.4997 3.5C7.92235 3.5 5.83301 5.58934 5.83301 8.16667C5.83301 10.744 7.92235 12.8333 10.4997 12.8333Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 24.4999V22.1666C25.6662 21.1326 25.3221 20.1282 24.6886 19.311C24.0551 18.4938 23.1681 17.9101 22.167 17.6516",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 3.65161C19.6708 3.90863 20.5605 4.49243 21.1959 5.31097C21.8313 6.12952 22.1761 7.13625 22.1761 8.17244C22.1761 9.20864 21.8313 10.2154 21.1959 11.0339C20.5605 11.8525 19.6708 12.4363 18.667 12.6933",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.ffd68d680874c594b7e97c350a3c29dc.svg";
export { ForwardRef as ReactComponent };